
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SessionCard from './SessionCard';


const styles = theme => ({
  card: {
    minWidth: 275,
    [theme.breakpoints.up('md')]: {
      marginLeft: 330,
    },

  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  author: {
    fontSize: 14,
  },
  actions: {
    display: 'flex',
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    marginLeft: 'auto',
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  pos: {
    marginBottom: 12,
  },
  drawer: {
      position: 'relative',
  }
});

const makeCancelable = (promise) => {
  let hasCanceled_ = false;

  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(
      val => hasCanceled_ ? reject({isCanceled: true}) : resolve(val),
      error => hasCanceled_ ? reject({isCanceled: true}) : reject(error)
    );
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
    },
  };
};

class CardContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { indexPresentations: [], expanded: false };
  }

  onSetResult = (result) => {
    this.setState({ indexPresentations: result });
    setTimeout(() => this.props.displayLoadIndicator(false),700);
  };

  handleExpandClick = () => {
    this.setState(state => ({ expanded: !state.expanded }));
  };


  cancelablePromise = makeCancelable(
    fetch("https://www.seatingsymposium.us/app/rest/schedules/"+this.props.scheduleid+"/presentations").then(response => response.json()).then(result => this.onSetResult(result))
  );

  componentWillMount() {
    this.props.displayLoadIndicator(true);
    this.cancelablePromise
    .promise.then().catch((reason) => console.log('isCanceled', reason.isCanceled));
    //fetch("https://www.seatingsymposium.us:8443/app/rest/schedules/"+this.props.scheduleid+"/presentations").then(response => response.json()).then(result => this.onSetResult(result));
  }

  componentWillUnmount() {
    this.cancelablePromise.cancel();
  }

  render() {
    const { classes } = this.props;
    //const bull = <span className={classes.bullet}>•</span>;

    return (
      <div>
        {this.state.indexPresentations.map((item,itemKey) => {
          return(
            <SessionCard classes={classes} session={item} key={item.id+itemKey}/>
          );
        })}
      </div>
    );
  }
}

CardContainer.propTypes = {
  classes: PropTypes.object.isRequired,
  scheduleid: PropTypes.number,
  displayLoadIndicator: PropTypes.func,
};

export default withStyles(styles)(CardContainer);